import React from 'react';
import ReactDOM from 'react-dom';
import { enableES5 } from 'immer';
import {
    postVerificationSizeUpdates, setOptions, overrideComponent, setMetadata,
} from '@sheerid/jslib';

import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepStudentPersonalInfoComponent } from './components/steps/StepStudentPersonalInfo/StepStudentPersonalInfoComponent';
import { StepSuccessComponent } from './components/steps/StepSuccess/StepSuccessComponent';
import { StepDocUploadComponent } from './components/steps/StepDocUpload/StepDocUploadComponent';
import { getQueryParamsByName } from './lib/utils/browser';
import { StepErrorComponent } from './components/steps/StepError/StepErrorComponent';

const verificationId = getQueryParamsByName('verificationId') || '';

setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();
enableES5();
setMetadata({ verificationId });

// @ts-expect-error
overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent);
// @ts-expect-error
overrideComponent('StepDocUploadComponent', StepDocUploadComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);
// @ts-expect-error
overrideComponent('StepErrorComponent', StepErrorComponent);

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);


